import { AppLoginPlatform } from '..';

export interface IAPIControlAccountItem {
  readonly Applicant: string;
  readonly ControlAccountUserID: string;
  readonly CreateTime: Date;
  readonly ExpireTime: string;
  readonly Password: string;
  readonly Status: number;
  readonly id: number;
}

export interface IAPIControlAccountBody {
  readonly Applicant: string;
  readonly Password: string;
  readonly ExpireTime: number;
  readonly ControlAccountUserID: string;
}

export interface IAPICreateAccountRoleBody {
  readonly userID: string[];
  readonly studioID: string[];
}

export interface IAPIResetPasswordBody {
  readonly email: string;
  readonly password: string;
  readonly sourcePlatform?: AppLoginPlatform;
}

export interface IEffectiveEnvItem {
  studioID: string;
  gameID: string;
  envID: number;
}

export interface IMoreEffectiveEnvItem {
  studioID: string;
  gameID: string;
  envID: number;
  moreEnvInfos: ReadonlyArray<IEffectiveEnvItem>;
}

export interface ICreateSupportAccountBody {
  ApplicantUserID: string;
  RequestDurationSec: number;
  ApplicationReason: string;
  EffectiveEnvInfo: IMoreEffectiveEnvItem;
  Fingerprint: string;
  DataSyncID?: string;
}

export enum SupportAccountRequestStatus {
  AwaitApproval = 'awaitApproval', // 待审批
  Active = 'active', // 启用中
  Expired = 'expired', // 已过期
  Rejected = 'rejected', // 已驳回
}

export interface ISupportAccountEnv {
  studioName: {
    StudioID: string;
    Name: string;
  };
  gameName: {
    GameID: string;
    Name: string;
  };
  envName: {
    id: number;
    Name: string;
    Type: string;
  };
  moreEnvInfos?: ReadonlyArray<ISupportAccountEnv>;
}

export interface IAPISupportAccountItem {
  id: number;
  DataSyncID?: string;
  ApplicantUserID: string;
  RequestDurationSec: number;
  ApplicationReason: string;
  Status: SupportAccountRequestStatus;
  EffectiveEnvInfo: string;
  Fingerprint: string;
  ApproverUserID?: string;
  EffectiveTime: string;
  CreateTime: string;
  envInfoRelationRes: ISupportAccountEnv;
  SupportLoginAccount?: string;
  ModifyTime: string;
  RejectionReason: string;
  RawLoginPassword?: string;
}
